import EditorPadding from "@/helpers/cms/EditorPadding.js";

export default class EditorMargin extends EditorPadding{
    constructor(data) {
        if (!data) {
            data = {left:0, top: 0, right: 0, bottom: 0};
        }
        super(data);
    }
}
